export default __webpack_public_path__ + "static/media/blogDetail4.39de5ec9.png";